import { orderBy } from 'lodash'
import { ExperimentItemProps } from '../components/ExperimentListItem/ExperimentItem'
import { GoalItemProps } from '../components/GoalListItem/GoalItem'
import { DirectionItemProps } from '../components/Page4-directions/DirectionItem'
import { MetricProgressLineProps } from '../components/Page6-metric-analytic/Page6-metric-analytic'
import { ReportDirectionLevels } from '../types/report.input.types'
import { useReportInputData } from './useReportInputData'

export const useSelectReportData = () => {
  const reportQuery = useReportInputData()

  const report = reportQuery?.data

  const isSalesPart = !reportQuery?.data?.report?.disable_sales

  const experimentItems: ExperimentItemProps[] =
    report?.data?.input?.experiments?.map((exInput, i) => {
      const exData = report?.data?.fields?.experiments?.find((e) => e.id === exInput.id)
      const score1 = report?.data?.events[exInput?.eventId1]
      const score2 = report?.data?.events[exInput?.eventId2]
      return {
        index: i + 1,
        img: exData?.img || '',
        title: `${exData?.title} ${exInput?.manual_description}` || '',
        score1: score1,
        score2: score2,
        science_description: exData?.science_description || '',
      }
    }) || []

  const mainGoalId = report?.data?.input?.goals?.find((g) => g?.main)?.id
  const mainGoal = report?.data?.fields?.goals?.find((g) => g?.id === mainGoalId)

  const selectedDirectionInput = report?.data?.input?.directions || []
  const directionItems: DirectionItemProps[] =
    sortDirectionsByLevel(selectedDirectionInput).map((dirInp, i) => {
      const dirData = report?.data?.fields?.directions?.find((d) => d?.id === dirInp?.id)
      return {
        index: i + 1,
        img: dirData?.img || '',
        title: dirData?.title || '',
        level: dirInp?.level || '',
      }
    }) || []

  const goalsInput = report?.data?.input?.goals || []
  const goalsInpSorted = orderBy(goalsInput, (g) => !g.main)
  const goalsItems: GoalItemProps[] = goalsInpSorted.map((goalInp, i) => {
    const goalData = report?.data?.fields?.goals?.find((g) => g?.id === goalInp.id)
    return {
      index: i + 1,
      title: goalData?.title || '',
    }
  })

  const metricItems: MetricProgressLineProps[] =
    report?.data?.page?.metricsFrom0to14?.metrics?.map((m) => {
      return {
        rank: m.rank,
        value: m?.value,
        title: m.param_name,
        param_key: m.param_key,
        param_name: m.param_name,
      }
    }) || []

  const isNoExperiments = !experimentItems?.length
  const isNoGoals = !goalsItems?.length
  const isNoDirections = !directionItems?.length

  return {
    experimentItems,
    directionItems,
    mainGoal,
    goalsItems,
    metricItems,
    isNoExperiments,
    isNoGoals,
    isNoDirections,
    isSalesPart,
    report,
  }
}

const sortDirectionsByLevel = (dir: { id: string; level: ReportDirectionLevels }[] | undefined) => {
  if (!dir) return []
  return orderBy(dir, [{ level: ReportDirectionLevels.EASY }, { level: ReportDirectionLevels.TRICKY }, { level: ReportDirectionLevels.HARD }], ['desc', 'desc', 'desc'])
}
